// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__8EaK8","title":"ClientInsurance_title__1W_Nc","itemText":"ClientInsurance_itemText__DCwPe"};